module.exports = __webpack_public_path__ + "09_mole.8b75da0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/09_mole.png
// module id = r2gG
// module chunks = 0